import React from "react"
import { loadUserLogin } from "../../../../../config"
import { toMeter } from "../../../../helpers/TextHelper"
import { timeStampToDate } from "../../../../helpers/DateHelper"
import { sortCaret } from "../../../../../_metronic/_helpers"
import { formatterRowComponent } from "../../../../../component/atoms/Tabel"
import { Card, CardBody } from "../../../../../_metronic/_partials/controls"
import { EmptyCard, TableSkeleton, TableView } from "../../../../../component"
import { linkWithCtrl } from "../../../../helpers/Utils"
import { useTranslation } from "react-i18next"
import { PRIVILEGE_ENUM } from "../../../../../constants/PrivilegeConstants.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { AREA_REGISTERED_ENUM } from "../../../../../constants/StringConstant.js"

export const TableActivityKur = ({ data, general, changePage, history, isFilter }) => {
  const privileges = loadUserLogin().privilege
  const { t } = useTranslation()

  const uiCode = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">{e?.area_name ?? "-"}</p>
        <span className="text-muted font-weight-bold d-block">
          {e?.area_size ? toMeter(e?.area_size) : "-"}
        </span>
      </>
    )
  }
  const uiFarmer = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">
          {e?.farmer_name ? e?.farmer_name : "-"}
        </p>
        <span className="text-muted font-weight-bold d-block">
          {e?.farmer_code ? e?.farmer_code : "-"}
        </span>
      </>
    )
  }
  const uiMitra = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">{e?.mitra_name ?? "-"}</p>
        <span className="text-muted font-weight-bold d-block">{e?.mitra_code ?? "-"}</span>
      </>
    )
  }
  const uiPlant = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">
          {e?.plant_type_name ? e?.plant_type_name : "-"}
        </p>
        <span className="text-muted font-weight-bold d-block">
          {e?.plant_type_varietas ? e?.plant_type_varietas : "-"}
        </span>
      </>
    )
  }
  const uiType = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">{e?.activity_name ?? "-"}</p>
      </>
    )
  }

  const uiCreatedDate = (e) => {
    const dateConvert = e?.submitted_date ? timeStampToDate(e?.submitted_date, "dd-MM-yyyy") : "-"
    const TimeConvert = e?.submitted_date ? timeStampToDate(e?.submitted_date, "HH:mm:ss") : "-"

    return (
      <>
        <p className="text-dark mb-1 font-size-lg">
          {dateConvert} <br /> {TimeConvert}
        </p>
      </>
    )
  }

  const columns = [
    {
      dataField: "plantingSeason.area.name",
      text: t("table_header_area_name"),
      sort: false,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      }
    },
    {
      dataField: "plantingSeason.area.farmer.account.name",
      text: t("table_header_farmer"),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiFarmer
      }
    },
    {
      dataField: "plantingSeason.area.farmer.account.mitra.name",
      text: t("table_header_mitra"),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiMitra
      }
    },
    {
      dataField: "plant_name",
      text: t("table_header_planting_type"),
      sort: false,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiPlant
      }
    },
    {
      dataField: "activity_name",
      text: t("table_header_activity_type"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiType
      }
    },
    {
      dataField: "createdDate",
      text: t("table_header_created_date"),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCreatedDate
      }
    }
  ]

  const linkDetail = (area_id, type, id, e) => {
    const url = RoutesConstants.AREA.DETAIL_ACTIVITY_TYPE_CUSTOM(AREA_REGISTERED_ENUM.MT_ACTIVE, area_id, type, id)

    if (e?.ctrlKey) {
      linkWithCtrl(url)
    } else {
      history.push(url)
    }
  }

  return (
    <>
      <Card className="card-shadowless">
        <CardBody>
          {general.loading ? (
            <TableSkeleton column={7} row={10} />
          ) : data?.pageDataActivity?.length == 0 ? (
            <EmptyCard
              body={
                isFilter
                  ? t("messages_response_data_not_found")
                  : t("messages_response_empty_state")
              }
            />
          ) : (
            ""
          )}
          <TableView
            callbackAfterPageChange={changePage}
            columnProperties={columns}
            dataTable={data?.pageDataActivity}
            currentPage={data?.pageActivity?.currentPage}
            currentElement={data?.pageActivity?.currentElement}
            totalCount={data?.pageActivity?.totalCount}
            loadingGetData={general.loading}
            ignoreSinglePage
            rowClasses={() => {
              return "cursor-pointer"
            }}
            rowEvents={{
              onClick: (e, row) => {
                if (
                  privileges.indexOf(
                    PRIVILEGE_ENUM["DETAIL_ACTIVITY_" + row?.activity_type_enum?.toUpperCase()]
                  ) > -1 &&
                  e.target.cellIndex < 6
                ) {
                  linkDetail(row?.area_id, row?.activity_type_enum?.toLowerCase(), row.id, e)
                }
              }
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}